/**
 * PostMeetingReviewWidget — TASK-673 (canvas-native review).
 *
 * The post-meeting review (summary, tasks, compliance, follow-up, DNA) as a summonable
 * canvas tile, so the meeting flow never routes out to a full page — the last remaining
 * route-out in the lifecycle. `PostMeetingPage` self-fetches everything from the session id;
 * this only supplies the frame and the id.
 */

import { WidgetContainer } from '../WidgetContainer';
import PostMeetingPage from '../../meeting/postmeeting/PostMeetingPage';

interface PostMeetingReviewWidgetProps {
  sessionId?: string;
  clientName?: string;
}

export function PostMeetingReviewWidget({ sessionId, clientName }: PostMeetingReviewWidgetProps) {
  if (!sessionId) {
    return (
      <WidgetContainer title="Review & document">
        <p className="p-4 text-sm text-muted-foreground">No meeting selected to review.</p>
      </WidgetContainer>
    );
  }
  return (
    <WidgetContainer title={clientName ? `Review — ${clientName}` : 'Review & document'}>
      <PostMeetingPage meetingId={sessionId} embedded />
    </WidgetContainer>
  );
}

export default PostMeetingReviewWidget;
